module.exports = __webpack_public_path__ + "img/ASQ_logo_draft_wb.f6aa6e5d.png";